import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted, provide, ref } from 'vue';
import { ClientSize } from './views/home/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const root = ref<Element | null>(null);

const clientWidth = document.body.clientWidth;
const clientHeight = document.body.clientHeight;
const clientSize: ClientSize = {
  width: clientWidth > 1280 ? document.body.clientWidth : 1280,
  height: clientHeight,
  menuSize: clientWidth >= 987 ? 190 : 64,
  minWidth: clientWidth > 1920 ? 330 : 270,
};
provide('ClientSize', clientSize);
onMounted(() => provide('rootRef', root.value));

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", {
    id: "app",
    ref_key: "root",
    ref: root
  }, [
    _createVNode(_component_router_view)
  ], 512))
}
}

})